export default __webpack_public_path__ + "media/images/borders/brown-light-border-64980c54d340cc69e3843a0b46192de5.svg";